import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c02f356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in items-center" }
const _hoisted_2 = ["checked", "disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "toggle-label block overflow-hidden h-7 rounded-full bg-gray-300 cursor-pointer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: _ctx.modelValue,
      disabled: _ctx.disabled,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateValue($event))),
      class: "toggle-checkbox absolute block w-7 h-7 rounded-full bg-white border-4 appearance-none cursor-pointer disabled:cursor-not-allowed"
    }, null, 40, _hoisted_2),
    _hoisted_3
  ]))
}